/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// French (Français)
export default {
	'Type something': 'Ecrivez ici',
	'About Jodit': 'A propos de Jodit',
	'Jodit Editor': 'Editeur Jodit',
	"Jodit User's Guide": "Guide de l'utilisateur",
	'contains detailed help for using': "Aide détaillée à l'utilisation",
	'For information about the license, please go to our website:':
		'Consulter la licence sur notre site web:',
	'Buy full version': 'Acheter la version complète',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. Tous droits réservés.',
	Anchor: 'Ancre',
	'Open in new tab': 'Ouvrir dans un nouvel onglet',
	'Open in fullsize': "Ouvrir l'éditeur en pleine page",
	'Clear Formatting': 'Supprimer le formattage',
	'Fill color or set the text color':
		'Modifier la couleur du fond ou du texte',
	Redo: 'Refaire',
	Undo: 'Défaire',
	Bold: 'Gras',
	Italic: 'Italique',
	'Insert Unordered List': 'Liste non ordonnée',
	'Insert Ordered List': 'Liste ordonnée',
	'Align Center': 'Centrer',
	'Align Justify': 'Justifier',
	'Align Left': 'Aligner à gauche ',
	'Align Right': 'Aligner à droite',
	'Insert Horizontal Line': 'Insérer une ligne horizontale',
	'Insert Image': 'Insérer une image',
	'Insert file': 'Insérer un fichier',
	'Insert youtube/vimeo video': 'Insérer une vidéo',
	'Insert link': 'Insérer un lien',
	'Font size': 'Taille des caractères',
	'Font family': 'Famille des caractères',
	'Insert format block': 'Bloc formatté',
	Normal: 'Normal',
	'Heading 1': 'Titre 1',
	'Heading 2': 'Titre 2',
	'Heading 3': 'Titre 3',
	'Heading 4': 'Titre 4',
	Quote: 'Citation',
	Code: 'Code',
	Insert: 'Insérer',
	'Insert table': 'Insérer un tableau',
	'Decrease Indent': 'Diminuer le retrait',
	'Increase Indent': 'Retrait plus',
	'Select Special Character': 'Sélectionnez un caractère spécial',
	'Insert Special Character': 'Insérer un caractère spécial',
	'Paint format': 'Cloner le format',
	'Change mode': 'Mode wysiwyg <-> code html',
	Margins: 'Marges',
	top: 'haut',
	right: 'droite',
	bottom: 'Bas',
	left: 'gauche',
	Styles: 'Styles',
	Classes: 'Classes',
	Align: 'Alignement',
	Right: 'Droite',
	Center: 'Centre',
	Left: 'Gauche',
	'--Not Set--': '--Non disponible--',
	Src: 'Source',
	Title: 'Titre',
	Alternative: 'Alternative',
	Filter: 'Filtre',
	Link: 'Lien',
	'Open link in new tab': 'Ouvrir le lien dans un nouvel onglet',
	Image: 'Image',
	file: 'fichier',
	Advanced: 'Avancé',
	'Image properties': "Propriétés de l'image",
	Cancel: 'Annuler',
	Ok: 'OK',
	'Your code is similar to HTML. Keep as HTML?':
		'Votre texte que vous essayez de coller est similaire au HTML. Collez-le en HTML?',
	'Paste as HTML': 'Coller en HTML?',
	Keep: "Sauvegarder l'original",
	Clean: 'Nettoyer',
	'Insert as Text': 'Coller en tant que texte',
	'Word Paste Detected': "C'est peut-être un fragment de Word ou Excel",
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		"Le contenu que vous insérez provient d'un document Microsoft Word / Excel. Voulez-vous enregistrer le format ou l'effacer?",
	'Insert only Text': 'Coller le texte seulement',
	'File Browser': 'Explorateur de fichiers',
	'Error on load list': 'Erreur de liste de chargement',
	'Error on load folders': 'Erreur de dossier de chargement',
	'Are you sure?': 'Etes-vous sûrs ?',
	'Enter Directory name': 'Entrer le nom de dossier',
	'Create directory': 'Créer un dossier',
	'type name': 'type de fichier',
	'Drop image': 'Coller une image',
	'Drop file': 'Déposer un fichier',
	'or click': 'ou cliquer',
	'Alternative text': 'Texte de remplacemement',
	Browse: 'Chercher',
	Upload: 'Charger',
	Background: 'Arrière-plan',
	Border: 'Bordure',
	Text: 'Texte',
	Top: 'Haut',
	Middle: 'Milieu',
	Bottom: 'Bas',
	'Insert column before': 'Insérer une colonne avant',
	'Insert column after': 'Insérer une colonne après',
	'Insert row above': 'Insérer une ligne au dessus',
	'Insert row below': 'Insérer une ligne en dessous',
	'Delete table': 'Supprimer le tableau',
	'Delete row': 'Supprimer la ligne',
	'Delete column': 'Supprimer la colonne',
	'Empty cell': 'Vider la cellule',
	'Chars: %d': 'Symboles: %d',
	'Words: %d': 'Mots: %d',
	Split: 'Split',
	'Split vertical': 'Split vertical',
	'Split horizontal': 'Split horizontal',
	'Strike through': 'Barrer',
	Underline: 'Souligner',
	superscript: 'exposant',
	subscript: 'indice',
	'Cut selection': 'Couper la sélection',
	'Select all': 'Tout sélectionner',
	Break: 'Pause',
	'Search for': 'Rechercher',
	'Replace with': 'Remplacer par',
	Replace: 'Remplacer',
	Paste: 'Coller',
	'Choose Content to Paste': 'Choisissez le contenu à coller',
	source: 'la source',
	bold: 'gras',
	italic: 'italique',
	brush: 'pinceau',
	link: 'lien',
	undo: 'annuler',
	redo: 'refaire',
	table: 'tableau',
	image: 'image',
	eraser: 'gomme',
	paragraph: 'clause',
	fontsize: 'taille de police',
	video: 'Video',
	font: 'police',
	about: "à propos de l'éditeur",
	print: 'impression',
	underline: 'souligné',
	strikethrough: 'barré',
	indent: 'indentation',
	outdent: 'retrait',
	fullsize: 'taille réelle',
	shrink: 'taille conventionnelle',
	hr: 'la ligne',
	ul: 'Liste',
	ol: 'Liste numérotée',
	cut: 'Couper',
	selectall: 'Sélectionner tout',
	'Open link': 'Ouvrir le lien',
	'Edit link': 'Modifier le lien',
	'No follow': 'Attribut Nofollow',
	Unlink: 'Supprimer le lien',
	Eye: 'Voir',
	pencil: 'Pour éditer',
	' URL': 'URL',
	Reset: 'Restaurer',
	Save: 'Sauvegarder',
	'Save as ...': 'Enregistrer sous',
	Resize: 'Changer la taille',
	Crop: 'Taille de garniture',
	Width: 'Largeur',
	Height: 'Hauteur',
	'Keep Aspect Ratio': 'Garder les proportions',
	Yes: 'Oui',
	No: 'Non',
	Remove: 'Supprimer',
	Select: 'Mettre en évidence',
	'Select %s': 'Mettre en évidence: %s',
	Update: 'Mettre à jour',
	'Vertical align': 'Alignement vertical',
	Merge: 'aller',
	'Add column': 'Ajouter une colonne',
	'Add row': 'Ajouter une rangée',
	Delete: 'Effacer',
	'Horizontal align': 'Alignement horizontal',
	'Sort by changed': 'Trier par modification',
	'Sort by name': 'Trier par nom',
	'Sort by size': 'Trier par taille',
	'Add folder': 'Créer le dossier',
	'You can only edit your own images. Download this image on the host?':
		"Vous ne pouvez éditer que vos propres images. Téléchargez cette image sur l'hôte?",
	'The image has been successfully uploaded to the host!':
		"L'image a été téléchargée avec succès sur le serveur!",
	palette: 'Palette',
	'There are no files': "Il n'y a aucun fichier dans ce répertoire.",
	Rename: 'renommer',
	'Enter new name': 'Entrez un nouveau nom',
	preview: 'Aperçu',
	download: 'Télécharger',
	'Paste from clipboard': 'Coller à partir du presse-papiers',
	"Your browser doesn't support direct access to the clipboard.":
		"Votre navigateur ne prend pas en charge l'accès direct au presse-papiers.",
	'Copy selection': 'Copier la sélection',
	copy: 'copie',
	'Border radius': 'Rayon des bordures',
	'Show all': 'Afficher tous',
	Apply: 'Appliquer',
	'Please fill out this field': 'Veuillez remplir ce champ',
	'Please enter a web address': 'Veuillez entrer une adresse web',
	Default: 'Par défaut',
	Circle: 'Cercle',
	Dot: 'Point',
	Quadrate: 'Quadratique',
	Find: 'Trouver',
	'Find Previous': 'Précédent',
	'Find Next': 'Suivant',
	'Insert className': 'Insérer un nom de classe',
	'Press Alt for custom resizing':
		'Appuyez sur Alt pour un redimensionnement personnalisé',
	'Embed code': "Code d'intégration",
	Edit: 'Modifier',
	All: 'Tout sélectionner',
	'License: %s': 'Licence: %s'
};
